// _Bill.jsx
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import {useMaterialUIController} from "context";
import dayjs from "dayjs";
import {Typography} from "@mui/material";
import properties from "constants/ApplicationConstants";

function _Bill({
  empId,
  username,
  empType,
  joiningDate,
  designation,
  email,
  noticePeriod,
  extension,
  CTC,
  reportingName,
  probationStartDate,
  probationEndDate,
  noGutter
}) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  return (
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={2}
      mb={noGutter ? 0 : 1}
      mt={1}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        {/* First Row */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Emp ID:
              </Typography>
              <Typography
                variant="caption"
                fontWeight="medium"
                textTransform="capitalize"
                fontFamily={properties.fontFamily}
              >
                {empId ? empId : "NA"}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Employee Type:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {empType ? empType.charAt(0).toUpperCase() + empType.slice(1) : "NA"}{" "}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Joining Date:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {joiningDate ? joiningDate : "NA"}
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        {/* Second Row */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Designation:
              </Typography>
              <Typography
                variant="caption"
                fontWeight="medium"
                textTransform="capitalize"
                fontFamily={properties.fontFamily}
              >
                {designation ? designation : "NA"}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Official Email ID:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {email ? email : "NA"}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Username:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {username ? username : "NA"}
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        {/* Third Row */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Notice Period:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {noticePeriod ? noticePeriod : "NA"}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Extension:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {extension ? extension : "NA"}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                CTC:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {CTC ? CTC : "NA"}
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        {/* Fourth Row */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Reporting To:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {reportingName ? reportingName : "NA"}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Probation Start Date:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {probationStartDate ? probationStartDate : "NA"}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <MDBox display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                Probation End Date:
              </Typography>
              <Typography variant="caption" fontWeight="medium" fontFamily={properties.fontFamily}>
                {probationEndDate ? probationEndDate : "NA"}
              </Typography>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

_Bill.defaultProps = {
  noGutter: false,
  probationStartDate: "NA",
  probationEndDate: "NA"
};

_Bill.propTypes = {
  empId: PropTypes.string,
  username: PropTypes.string,
  empType: PropTypes.string,
  joiningDate: PropTypes.string,
  designation: PropTypes.string,
  email: PropTypes.string,
  noticePeriod: PropTypes.string,
  extension: PropTypes.string,
  reportingName: PropTypes.string,
  probationStartDate: PropTypes.string,
  probationEndDate: PropTypes.string,
  noGutter: PropTypes.bool
};

export default _Bill;
